import { Megaphone, Search, Music2, Bot, Cloud, ShoppingCart, Globe, CreditCard } from "lucide-react";
import { useLang } from "../context/LangContext";
import { Reveal } from "./Reveal";

const ICONS = [Megaphone, Search, Music2, Bot, Cloud, ShoppingCart, Globe, CreditCard];

export const UseCases = () => {
  const { t } = useLang();
  const c = t.useCases;

  return (
    <section id="solutions" className="relative py-20 lg:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-violet-500/30 to-transparent" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-blue-400">{c.tag}</span>
          <h2 className="mt-4 font-display text-3xl font-black leading-tight text-white sm:text-4xl lg:text-5xl">
            {c.titleA}
            <br />
            <span className="text-gradient">{c.titleB}</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-slate-400 sm:text-base">{c.desc}</p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-4">
          {c.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.05}>
                <div
                  data-testid={`use-case-${i}`}
                  className="group glass flex h-full flex-col items-center rounded-2xl p-6 text-center transition-all duration-500 hover:-translate-y-1 hover:border-blue-400/30 hover:bg-white/[0.04] sm:p-7"
                >
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-blue-600/25 to-violet-600/25 text-blue-300 transition-all duration-500 group-hover:shadow-[0_0_20px_rgba(59,130,246,0.45)]">
                    <Icon className="h-5 w-5" />
                  </div>
                  <p className="mt-4 text-sm font-bold text-slate-200">{item}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
